import { Component, ViewChild, ViewEncapsulation } from '@angular/core';
import { WcGridComponent } from '../../components/wc-grid/wc-grid.component';
import { HttpService } from '../../utility/http-service';
import { RouterService } from '../../utility/router-service';
import { DialogService } from '../../utility/dialog/dialog-service';
import { ModalType } from '../../utility/dialog-template/dialog-template.component';

@Component({
  selector: 'pending-users',
  standalone: false,
  encapsulation: ViewEncapsulation.None,
  templateUrl: './pending-users.component.html',
  styleUrl: './pending-users.component.css'
})
export class PendingUsersComponent {

  @ViewChild('pendingGrid') pendingGrid?: WcGridComponent;

  selectedUser: any = null;

  constructor(
    private http: HttpService,
    private router: RouterService,
    private dialogService: DialogService
  ) {}

  reload(): void {
    this.pendingGrid?.reload(1);
  }

  onUserSelected(row: any): void {
    this.selectedUser = row;
  }

  approveUser(): void {
    const record = this.selectedUser;
    if (!record) return;
    this.dialogService.openModal(
      'Approve User',
      `Are you sure you want to approve ${record.Email} for login?`,
      ModalType.QUESTION,
      () => {
        const formData = new FormData();
        formData.append('id', record.Id);
        this.http.post('User/ApproveUser', () => this.router.reloadPage(), null, formData);
      },
      () => {}
    );
  }

  declineUser(): void {
    const record = this.selectedUser;
    if (!record) return;
    this.dialogService.openModal(
      'Reject User',
      `Are you sure you want to reject ${record.Email}?`,
      ModalType.QUESTION,
      () => {
        const formData = new FormData();
        formData.append('id', record.Id);
        this.http.post('User/DeclineUser', () => this.router.reloadPage(), null, formData);
      },
      () => {}
    );
  }
}
